<template>
  <bxs-bottom-sheets
    v-model="visible"
    class="export_images_sheets"
    :hide-header="true"
    height="full"
    :prevent-scroll-through="true"
    :overlay="overlay"
  >
    <ExportImages
      :scene="scene"
      :plain-result-data="plainResultData"
      :liability-show-type="Number(liabilityShowType)"
      :is-show-interest-table="!!interestData"
      :theme-settings="themeSettings"
      @screen-capture="(cb) => $emit('screen-capture', cb)"
      @openThemePicker="$emit('openThemePicker')"
      @openInterestSettingPopup="$emit('openInterestSettingPopup')"
      @cancel="cancel"
    />
  </bxs-bottom-sheets>
</template>
<script>
import { BottomSheets } from 'bxs-ui-vue'
import ExportImages from './index.vue'

export default {
  components: {
    [BottomSheets.name]: BottomSheets,
    ExportImages
  },
  props: {
    value: Boolean,
    scene: Number,
    liabilityShowType: Number,
    plainResultData: Object,
    interestData: Object,
    themeSettings: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      overlay: false,
      activeIndex: 0
    }
  },
  computed: {
    visible: {
      get () {
        if (this.value) {
          this.init()
        }
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      },
    }
  },
  methods: {
    init () {
      this.overlay = true
      this.addHistoryState()
    },
    addHistoryState() {
      if (window.history && window.history.pushState) {
        history.pushState(null, null, location.href)
        window.addEventListener('popstate', () => {
          this.visible = false
        }, false)
      }
    },
    cancel () {
      this.visible = false
      history.go(-1)
    }
  }
}
</script>

<style lang="postcss">
.export_images_sheets {
  & .bx-sheets-scroll {
    height: 100%;
  }
}
</style>